//
//
//
//
//
//

export default {
  name: 'DistributionAgreement'
};